<template>
    <transition name="layout-fade">
        <v-layout wrap column class="layout-add layout-add--max_width">
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Новая новость или события</v-toolbar-title>
                <v-spacer/>
                <v-btn color="info" class="v-btn--save" :loading="loading" :disabled="loading" @click="sendForm">
                    Сохранить
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>
            <v-form class="form-add">
                <v-flex xs12>
                    <v-subheader class="pa-0">Название</v-subheader>
                    <v-text-field
                        ref="news_name"
                        v-model="news.name"
                        v-validate="'required'"
                        data-vv-name="name"
                        :error-messages="errors.collect('name')"
                        text
                        solo
                        single-line
                        required/>
                </v-flex>
                <v-flex xs12>
                    <v-layout>
                        <v-flex xs6>
                            <v-subheader class="pa-0">Короткое описание</v-subheader>
                            <v-textarea
                                ref="news_description"
                                v-model="news.description"
                                v-validate="'required|max:140'"
                                data-vv-name="description"
                                :error-messages="errors.collect('description')"
                                text
                                solo
                                single-line
                                required
                                counter="140"/>
                            <v-subheader class="pa-0">Статус</v-subheader>
                            <v-checkbox :label="news.status ? 'Включен' : 'Отключен'" v-model="news.status"
                                        class="mt-0"/>
                        </v-flex>
                        <v-spacer/>
                        <upload-img :image-width="800" :image-height="800" v-model="news.img" :content-area="5"
                                    style="max-width: 253px;">
                            <div slot="activator">
                                <v-avatar size="100%" v-ripple class="grey lighten-3" tile v-if="!news.img">
                                    <img src="/static/img/media/image_blank.svg"
                                         alt="Нажмите чтобы добавить картинку для новости"/>
                                </v-avatar>
                                <v-avatar size="100%" v-ripple tile v-else>
                                    <img :src="news.img.imageURL" alt="Изображение для новости"/>
                                </v-avatar>
                            </div>
                        </upload-img>
                    </v-layout>
                </v-flex>
                <v-flex xs12>
                    <v-subheader class="pa-0">Основной Текст</v-subheader>
                    <wysiwyg v-model="news.text"/>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import UploadImg from '../../../components/Media/Upload'
    import News from '../../../api/event'

    export default {
        name: 'addNews',
        components: { UploadImg },
        $_veeValidate: {
            validator: 'new'
        },
        data: () => ({
            loading: false,
            news: {
                name: '',
                description: '',
                text: '',
                status: true,
                img: ''
            },
            dictionary: {
                custom: {
                    name: {
                        required: 'Название не заполнено'
                    },
                    description: {
                        required: 'Заполните описание'
                    }
                }
            }
        }),
        mounted () {
            this.$validator.localize('ru', this.dictionary)
        },
        methods: {
            sendForm () {
                this.$validator
                    .validateAll()
                    .then(isValid => {
                        if (!isValid) return

                        this.loading = true

                        News
                            .create(this.news)
                            .then(response => {
                                this.$store.commit('addNewsEvent', response.data)
                                this.$store.commit('showSnackbar', {
                                    text: 'Успех! Запись создано',
                                    color: 'success'
                                })
                                this.$router.push({ name: 'newsEventsRoot' })
                            })
                            .catch(error => this.$store.commit('showSnackbar', { text: error.response.data.error[Object.keys(error.response.data.error)[0]][0] }))
                            .finally(() => this.loading = false)
                    })
                    .catch(error => new Error(error))
            }
        }
    }
</script>
